<div class="group-criteria-desc-images">
  <group-criteria-description-image
    [description]="'Member meets all criteria'"
    [image]="'in_group_and_meets_criteria.svg'"
    class="group-criteria-desc-image-small"
  ></group-criteria-description-image>
  <group-criteria-description-image
    [description]="'Member does not meet at least one criteria'"
    [image]="'in_group_but_does_not_meet_criteria.svg'"
    class="group-criteria-desc-image-large"
  ></group-criteria-description-image>
  <group-criteria-description-image
    [description]="'Recommended! Meets criteria, but not group member'"
    [image]="'out_of_group_but_meets_criteria.svg'"
    class="group-criteria-desc-image-large"
  ></group-criteria-description-image>
</div>
